console.log("devstren")

const cardQrCache = new Map();
let cardQrLib;

function loadCardQrLib() {
  if (window.QRCode) return Promise.resolve();
  if (!window.DevstrenQrSrc) return Promise.reject();
  if (cardQrLib) return cardQrLib;
  cardQrLib = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = window.DevstrenQrSrc;
    script.onload = () => resolve();
    script.onerror = () => {
      cardQrLib = null;
      reject();
    };
    document.head.appendChild(script);
  });
  return cardQrLib;
}

function paintCardQr(el) {
  if (!el || el.dataset.ready || !window.QRCode) return;
  const text = el.getAttribute('data-card-qr');
  if (!text) return;
  el.dataset.ready = '1';

  const cached = cardQrCache.get(text);
  if (cached) {
    const img = document.createElement('img');
    img.src = cached;
    img.alt = '';
    img.width = 64;
    img.height = 64;
    el.appendChild(img);
    return;
  }

  new QRCode(el, {
    text: text,
    width: 64,
    height: 64,
    colorDark: '#1c201e',
    colorLight: '#ffffff',
    imageAltText: 'QR code'
  });

  const canvas = el.querySelector('canvas');
  if (canvas) {
    cardQrCache.set(text, canvas.toDataURL());
    return;
  }
  const drawn = el.querySelector('img');
  if (drawn && drawn.src) cardQrCache.set(text, drawn.src);
}

function paintAllCardQr() {
  document.querySelectorAll('[data-card-qr]').forEach(paintCardQr);
}

function bootCardQr() {
  if (!window.DevstrenQrSrc) return;
  const pending = document.querySelector('[data-card-qr]:not([data-ready])');
  if (pending) loadCardQrLib().then(paintAllCardQr).catch(() => {});
  if (window.__cardQrWatch) return;
  window.__cardQrWatch = true;
  new MutationObserver(() => {
    if (!document.querySelector('[data-card-qr]:not([data-ready])')) return;
    loadCardQrLib().then(paintAllCardQr).catch(() => {});
  }).observe(document.body, { childList: true, subtree: true });
}

bootCardQr();

function zipFromQuery(value) {
  const match = (value || '').trim().match(/^(\d{5})(?:-\d{4})?$/);
  return match ? match[1] : '';
}

function zipCollectionUrl(zip) {
  const config = window.DevstrenZipSearch;
  if (!config || !zip) return '';
  const url = new URL(config.collectionUrl, window.location.origin);
  url.searchParams.set(config.param, zip);
  return url.toString();
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  const config = window.DevstrenZipSearch;
  if (!form || !config || !form.getAttribute) return;
  const action = form.getAttribute('action') || '';
  if (action.indexOf(config.searchPath) === -1) return;
  const input = form.querySelector('input[name="q"]');
  const next = zipCollectionUrl(zipFromQuery(input && input.value));
  if (!next) return;
  event.preventDefault();
  window.location.assign(next);
});

document.addEventListener('DOMContentLoaded', () => {
    const config = window.DevstrenZipSearch;
    if (config && window.location.pathname.indexOf(config.searchPath) !== -1) {
      const next = zipCollectionUrl(zipFromQuery(new URLSearchParams(window.location.search).get('q')));
      if (next) window.location.replace(next);
    }
    // Exact target wrapper div
    const targetWrapper = document.querySelector('.template-product .product__accordion.accordion.quick-add-hidden');
    
    if (targetWrapper) {
      // Wrapper ke andar pehla <details> tag locate karke 'open' attribute add kar do
      const firstDetails = targetWrapper.querySelector('details');
      if (firstDetails) {
        firstDetails.setAttribute('open', '');
      }
    }
  });